import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import BasicInput from 'Components/common/BasicInput';
import Dialog from 'Components/common/Dialog';
import OrderShipToDetail from 'Components/commonOrder/OrderShipToDetail';
import OrderBillToDetail from 'Components/commonOrder/OrderBillToDetail';
import OrderPurchaseNo from 'Components/commonOrder/OrderPurchaseNo';
import OrderRemark from 'Components/commonOrder/OrderRemark';
import OrderProductList from 'Components/commonOrder/OrderProductList';
import SkuInventoryDetailsDialog from 'Components/commonOrder/SkuInventoryDetailsDialog';
import ShippingPlanDialog from 'Components/commonOrder/ShippingPlanDialog';
import ShipmentReceiveWithOtherPhotosDialog from 'Components/host/ShipmentReceiveWithOtherPhotosDialog';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {loadLanguage} from 'Utils/jwtUtil';
import {USER_ROLE, base64ShippingImage} from 'Utils/constant';
import copy from 'copy-to-clipboard';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getOrderDetails,
    cancelOrder,
    cancelPackage,
    updateShipment,
    notShipOrder,
    waitShipOrder,
    createInvoicePdf,
    getSkuInventoryDetails,
    updateTrackingNumber,
    getShipmentPackageQuantity,
    getOrderDetailMessageCount,
    getOrderDetailOneKeyRead,
    forceCancelPickOrder,
    setShipmentsSource,
    setRevokePackageSuccess,
    setCurrentShipmentId,
    punchReceivable,
    b2bCasmartShipment,
    updateShipmentOrderDetails,
} from 'Actions/host';
import {getShippingPlanList, saveShippingPlan} from 'Actions/myOrder';
import {T} from 'Actions/translate';
import {RECEIVE_METHOD} from 'Utils/constant';

// Icons
import {ArrowBackIos, NavigateNext, Message, Info} from '@material-ui/icons';
import {batchRecommendPdfsUrl} from 'Utils/urlUtil';

const SHIPMENT_LIST_RESTORE_STORAGE_KEY = 'shipmentListRestoreState';

class ShipmentDetails extends React.Component {
    inputFileRef = React.createRef();
    state = {
        previewReceiveImageDialogOpened: false,
        previewOtherImagesDialogOpened: false,
        noOtherPhotosDialogOpened: false,
        uploadReceiveImageDialogOpened: false,
        cancelOrderDialogOpened: false,
        cancelWithdrawalPackage: false,
        waitSendGoodsDialogOpened: false,
        chooseShipmentItem: null,
        currentOtherImageIndex: 0,
        chooseImage: {file: null, url: ''},
        uploadFileBtnIsLoading: false,
        skuInventoryExitOpened: false,
        skuInventoryDetailData: [],
        sQuoteFailureDialogOpened: false,
        currentShipFlag: 0,
        currentShipmentId: '',
        currentOrderId: '',
        currentFinancialStatus: '',
        addTrackNumberDialogOpened: false,
        trackNumber: '',
        currentShipments: [],
        messageCount: {},
        opentForceShipDialog: false,
        tempPosition: [],
        currentB2bShipmentFlag: null,
        currentPurchaseNo: '',
        currentOrderNumber: '',
        currentOrderProducts: [],

        isOpenShippingPlanDialog: false,
        shippingPlanData: [],
        currentOrderData: '',
        currentOrderProduct: null,
        shippingPlanModalComps: [
            {
                shippingPlanId: 1,
                quantity: 1,
                shippingDate: util.dateFilter(
                    new Date().setDate(new Date().getDate()),
                    'yyyy-MM-dd',
                ),
                remark: '',
            },
        ],
        shippingPlanNum: 1,
        totalShippingQuantity: 0,
        currentTipMessage: '',
        showTip: false,
        detailsLoading: true,
    };

    componentWillMount() {
        this.getInitData();
    }

    componentDidUpdate(prevProps, prevState) {
        // 如果showTip从false变为true，并且3秒后还没有隐藏，则隐藏它
        if (prevState.showTip === false && this.state.showTip === true) {
            setTimeout(() => {
                this.setState({showTip: false});
            }, 3000);
        }
    }

    getOrderDetails = () =>
        this.props.getOrderDetails({
            id: this.params.orderId,
            includeShipments: true,
        });

    getInitData = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });

        const detailsRequest = this.getOrderDetails();

        detailsRequest
            .then(() => {
                this.setState({detailsLoading: false});
            })
            .catch((error) => {
                console.error('Failed to load shipment details:', error);
                this.setState({detailsLoading: false});
                this.props.openNotification(
                    T('notification_network_unstable'),
                    'danger',
                );
            });

        this.props.getShipmentPackageQuantity({
            orderId: this.params.orderId,
        });

        if (this.params.eoneNumber) {
            this.props
                .getOrderDetailMessageCount({
                    messageKey: this.params.eoneNumber,
                    messageMode: 'ORDER',
                })
                .then((res) => {
                    if (res && res.status === 'success' && res.data) {
                        this.setState({
                            messageCount: res.data,
                        });
                    }
                });
        }

        setTimeout(() => {
            this.setState({
                currentShipFlag: parseInt(this.params.shipFlag),
            });
        });
    };

    goBack = () => {
        this.props.setShipmentsSource({$set: true});
        this.props.history.goBack();
    };

    ensureShipmentRestoreState = () => {
        const {shipmentOrOrderDetails} = this.props;
        let restoreState = null;

        try {
            const restoreStateStr = sessionStorage.getItem(
                SHIPMENT_LIST_RESTORE_STORAGE_KEY,
            );
            restoreState = restoreStateStr ? JSON.parse(restoreStateStr) : null;

            if (!restoreState) {
                return null;
            }

            restoreState.orderNumber =
                shipmentOrOrderDetails && shipmentOrOrderDetails.number
                    ? shipmentOrOrderDetails.number
                    : restoreState.orderNumber;

            sessionStorage.setItem(
                SHIPMENT_LIST_RESTORE_STORAGE_KEY,
                JSON.stringify(restoreState),
            );
        } catch (err) {
            restoreState = null;
        }

        return restoreState;
    };

    getShipEditRouteState = () => {
        const restoreState = this.ensureShipmentRestoreState();

        return {
            forceShip: this.props.shipmentOrOrderDetails.isPicking,
            eoneNumber: this.props.shipmentOrOrderDetails.eoneNumber,
            returnToShipmentListTab:
                restoreState && restoreState.tab ? restoreState.tab : '',
        };
    };

    ship = () => {
        // const {messageCount} = this.state;
        // if (messageCount.unReadCount === 0) {
        //     if (this.props.shipmentOrOrderDetails.isPicking) {
        //         this.setState({
        //             opentForceShipDialog: true
        //         });
        //     } else {
        //         this.props.history.push(`/shipEdit/${this.params.orderId}`, {forceShip: this.props.shipmentOrOrderDetails.isPicking, eoneNumber: this.props.shipmentOrOrderDetails.eoneNumber})
        //     }
        // } else {
        //     this.props.openNotification(T('shipment_unread_message'), 'danger');
        // }

        if (this.props.shipmentOrOrderDetails.isPicking) {
            this.setState({
                opentForceShipDialog: true,
            });
        } else {
            this.props.history.push(
                `/shipEdit/${this.params.orderId}`,
                this.getShipEditRouteState(),
            );
        }
    };

    confirmForceShipHandle = () => {
        this.props.forceCancelPickOrder(this.params.orderId).then((res) => {
            if (res && res.status === 'success') {
                this.props.history.push(
                    `/shipEdit/${this.params.orderId}`,
                    this.getShipEditRouteState(),
                );
            }
        });
    };

    openCancelOrderDialog = () =>
        this.setState({cancelOrderDialogOpened: true});
    cancelOrder = () => {
        this.props
            .cancelOrder({orderId: this.params.orderId})
            .then((res) => {
                this.setState({cancelOrderDialogOpened: false});
                if (res.status === 'success') {
                    res.data.systemCancel
                        ? this.props.openNotification(
                              T('notification_successfully_cancel_the_order'),
                              'success',
                          )
                        : this.props.openNotification(
                              T(
                                  'notification_cancellation_request_has_been_sent',
                              ),
                              'success',
                          );

                    this.props.history.goBack();
                } else {
                    this.props.openNotification(
                        T('notification_order_cancellation_failed'),
                        'success',
                    );
                }
            })
            .catch((err) => {
                this.setState({cancelOrderDialogOpened: false});
                if (err.status === 'squote_order_not_allowed') {
                    this.setState({sQuoteFailureDialogOpened: true});
                }
            });
    };

    previewInvoice = (item) => {
        // this.props.createInvoicePdf({id: item.id}).then((res) => {
        //     if (util.isIOS()) {
        //         window.location.href = res.data;
        //     } else {
        //         window.open(res.data, '_blank');
        //     }
        // });
        this.props.createInvoicePdf({id: item.id}).then((res) => {
            if (util.isIOS()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-preview.html?url=' +
                    window.encodeURIComponent(
                        `${util.getImageRoot() + res.data}`,
                    );
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-preview.html?url=' +
                        window.encodeURIComponent(
                            `${util.getImageRoot() + res.data}`,
                        ),
                    '_blank',
                );
            }
        });
    };

    previewReceiveImage = (item) => {
        this.setState({
            chooseShipmentItem: item,
            previewReceiveImageDialogOpened: true,
        });
    };

    getPreviewImageUrl = (imageUrl) =>
        /^https?:\/\//.test(imageUrl)
            ? imageUrl
            : util.getImageRoot() + imageUrl;

    getShipmentReceiveMethod = (shipmentItem) =>
        shipmentItem && shipmentItem.receiveType === 2
            ? RECEIVE_METHOD.DELEGATE
            : RECEIVE_METHOD.CUSTOMER;

    getShipmentMainImageKey = (shipmentItem) =>
        !shipmentItem
            ? ''
            : this.getShipmentReceiveMethod(shipmentItem) ===
              RECEIVE_METHOD.DELEGATE
            ? shipmentItem.locationImg || ''
            : shipmentItem.receiveImg || '';

    getShipmentMainImageUrl = (shipmentItem) =>
        this.getPreviewImageUrl(this.getShipmentMainImageKey(shipmentItem));

    previewOtherImages = (item, currentOtherImageIndex = 0) => {
        this.setState({
            chooseShipmentItem: item,
            currentOtherImageIndex,
            previewOtherImagesDialogOpened: true,
        });
    };

    setPreviewOtherImageIndex = (currentOtherImageIndex) => {
        this.setState({currentOtherImageIndex});
    };

    b2bCasmartShipmentHandle = (params) => {
        this.props
            .b2bCasmartShipment(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    console.log(res);

                    if (util.isWechatBrowser()) {
                        if (util.isIOS()) {
                            window.location.href =
                                window.location.origin +
                                '/pdf-preview/pdf-preview.html?url=' +
                                window.encodeURIComponent(
                                    `${util.getImageRoot() + res.data}`,
                                );
                        } else {
                            window.open(
                                window.location.origin +
                                    '/pdf-preview/pdf-preview.html?url=' +
                                    window.encodeURIComponent(
                                        `${util.getImageRoot() + res.data}`,
                                    ),
                                '_blank',
                            );
                        }
                    } else {
                        window.open(res.data, '_blank');
                    }
                } else {
                    this.props.openNotification(T(res.message), 'danger');
                }
            })
            .catch((err) => {
                if (err && err.status === 'po_number_empty') {
                    this.props.openNotification(T('po_number_empty'), 'danger');
                } else if (
                    err &&
                    err.status === 'b2b_shipment_integration_error'
                ) {
                    this.props.openNotification(
                        T('order_contact_service'),
                        'danger',
                    );
                } else {
                    this.props.openNotification(T(err.message), 'danger');
                }
            });
    };

    handleUploadReceiveImageDialog = (item) => {
        this.props.punchReceivable(item.id).then((res) => {
            if (res && res.status === 'success') {
                if (res.data.punchEnabled === 'Y') {
                    if (res.data.hasPunched === 'Y') {
                        this.setState(
                            {
                                chooseShipmentItem: item,
                                uploadReceiveImageDialogOpened: true,
                                chooseImage: {file: null, url: ''},
                            },
                            () => {
                                if (this.inputFileRef.current) {
                                    this.inputFileRef.current.value = '';
                                }
                            },
                        );
                    } else {
                        this.props.openNotification(
                            T('shippment_upload_signed_first_punch'),
                            'danger',
                        );
                    }
                } else {
                    this.setState(
                        {
                            chooseShipmentItem: item,
                            uploadReceiveImageDialogOpened: true,
                            chooseImage: {file: null, url: ''},
                        },
                        () => {
                            if (this.inputFileRef.current) {
                                this.inputFileRef.current.value = '';
                            }
                        },
                    );
                }
            }
        });
    };

    chooseImage = () =>
        this.inputFileRef.current && this.inputFileRef.current.click();
    clearSelectedImage = () => {
        this.setState({chooseImage: {file: null, url: ''}});
        if (this.inputFileRef.current) {
            this.inputFileRef.current.value = '';
        }
    };
    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }
        const reader = new FileReader();
        const file = ev.target.files[0];
        reader.onload = (event) => {
            this.setState({chooseImage: {file, url: event.target.result}});
        };
        reader.readAsDataURL(file);
    };
    openWithdrawalPackage = () => {
        this.setState({
            cancelWithdrawalPackage: true,
            currentB2bShipmentFlag:
                this.props.shipmentOrOrderDetails.b2bShipmentFlag,
            currentPurchaseNo: this.props.shipmentOrOrderDetails.purchaseNo,
            currentOrderNumber: this.props.shipmentOrOrderDetails.eoneNumber,
            currentOrderProducts: this.props.shipmentOrOrderDetails.shipments,
        });
    };

    withdrawalPackage = () => {
        if (
            this.props.shipmentOrOrderDetails &&
            this.props.shipmentOrOrderDetails.shipments &&
            this.props.shipmentOrOrderDetails.shipments[0]
        ) {
            let id = this.props.shipmentOrOrderDetails.shipments[0]['id'];
            this.props
                .cancelPackage({id: id})
                .then((res) => {
                    this.setState(
                        {
                            cancelWithdrawalPackage: false,
                            currentOrderNumber: '',
                            currentPurchaseNo: '',
                            currentOrderProducts: [],
                            currentB2bShipmentFlag: null,
                        },
                        () => {
                            if (res['status'] && res['status'] === 'success') {
                                this.props.openNotification(
                                    T('package_withdrawn_successfully'),
                                    'success',
                                );
                                //刷新页面重新拉取当前列表
                                // this.getInitData();
                                this.props.setRevokePackageSuccess({
                                    $set: true,
                                });
                                this.props.setCurrentShipmentId({
                                    $set: parseInt(id),
                                });

                                setTimeout(() => {
                                    this.props.history.goBack();
                                }, 400);
                            }
                        },
                    );
                })
                .catch((err) => {
                    this.props.openNotification(
                        T('failed_to_withdraw_package'),
                        'danger',
                    );
                    this.setState({
                        cancelWithdrawalPackage: false,
                        currentOrderNumber: '',
                        currentPurchaseNo: '',
                        currentOrderProducts: [],
                        currentB2bShipmentFlag: null,
                    });
                });
        } else {
            //刷新页面重新拉取当前列表
            this.props.setShipmentsSource({$set: true});
            this.props.history.goBack();
        }
    };

    cancelDialog = () => {
        this.setState({
            cancelWithdrawalPackage: false,
            currentOrderNumber: '',
            currentPurchaseNo: '',
            currentOrderProducts: [],
            currentB2bShipmentFlag: null,
        });
    };

    openNotShipDialog = () => {
        this.setState({notShipDialogOpened: true});
    };
    openWaitSendGoodsDialog = () => {
        this.setState({waitSendGoodsDialogOpened: true});
    };
    notShip = () => {
        this.props
            .notShipOrder({orderId: this.params.orderId})
            .then((status) => {
                this.setState({notShipDialogOpened: false});
                this.props.openNotification(
                    T(
                        'notification_already_temporarily_does_not_deliver_goods',
                    ),
                    'success',
                );
                if (this.params.orderId) {
                    this.getOrderDetails();
                }
            })
            .catch((res) => {
                if (res && res.message) {
                    if (res.message === 'Black_Sku') {
                        this.setState({
                            notShipDialogOpened: false,
                        });
                        this.props.openNotification(
                            T(
                                'grey_list_products_can_not_be_temporarily_shipped',
                            ),
                            'danger',
                        );
                    }
                }
            });
    };

    waitSendGoods = () => {
        this.props
            .waitShipOrder({orderId: this.params.orderId})
            .then((status) => {
                this.setState({waitSendGoodsDialogOpened: false});
                this.props.openNotification(
                    T('notification_already_wait_query_deliver_list'),
                    'success',
                );
                if (this.params.orderId) {
                    this.getOrderDetails();
                }
            });
    };

    openTrackNumberDialog = (item) => {
        this.setState({
            addTrackNumberDialogOpened: true,
            currentShipments: item,
            trackNumber: item.expressNumber,
        });
    };

    handleChange = (name, value) => {
        this.setState({
            trackNumber: value,
        });
    };
    addTrackNumberHandle = () => {
        let {trackNumber, currentShipments} = this.state;
        let shipmentId = currentShipments.id;

        if (trackNumber.trim()) {
            this.props
                .updateTrackingNumber({
                    shipmentId: shipmentId,
                    expressNumber: trackNumber.trim(),
                })
                .then(() => {
                    this.props.openNotification(
                        T('shippment_update_tracking_number_success'),
                        'success',
                        {time: 2000},
                    );
                    this.setState({
                        trackNumber: '',
                        addTrackNumberDialogOpened: false,
                        currentShipments: [],
                    });
                    this.getInitData();
                });
        }
    };

    dialogDidClose = (key) =>
        this.state[key] &&
        this.setState({chooseShipmentItem: null, [key]: false});

    updateShipment = (payload) => {
        const {chooseShipmentItem} = this.state;

        this.props
            .updateShipment({
                shipmentId: chooseShipmentItem.id,
                ...payload,
            })
            .then((status) => {
                this.props.openNotification(
                    T('notification_successfully_upload'),
                    'success',
                );
                this.setState({
                    uploadReceiveImageDialogOpened: false,
                    chooseItem: null,
                });
                this.getInitData();
            });
    };

    showSkuInventoryDetailHandle = (supplyCenterId, productId, eoneNumber) => {
        this.props
            .getSkuInventoryDetails({
                supplyCenterId: supplyCenterId,
                productId: productId,
                eoneNumber: eoneNumber,
            })
            .then((res) => {
                if (res.status === 'success') {
                    this.openSkuInventoryDetailsDialog(res.data);
                }
            });
    };

    openSkuInventoryDetailsDialog = (name, data, shipData) => {
        this.setState({
            skuInventoryExitOpened: true,
            skuInventoryDetailData: data,
        });
    };

    closeDialog = (name) => {
        if (this.state.skuInventoryExitOpened) {
            this.setState({
                skuInventoryExitOpened: false,
                skuInventoryDetailData: [],
            });
        }
    };

    deliverInfor = () => {
        if (this.params.orderId) {
            this.props.history.push(
                `/deliverDetails?orderId=${this.params.orderId}`,
            );
        }
    };

    goToMessageList = () => {
        const {messageCount} = this.state;
        let currentShipmentOrOrderDetails = this.props.shipmentOrOrderDetails;
        if (
            currentShipmentOrOrderDetails &&
            currentShipmentOrOrderDetails.eoneNumber
        ) {
            if (messageCount.unReadCount > 0) {
                this.props
                    .getOrderDetailOneKeyRead({
                        messageKey: currentShipmentOrOrderDetails.eoneNumber,
                        messageMode: 'ORDER',
                    })
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.props.history.push(
                                `/messageList?eoneNumber=${currentShipmentOrOrderDetails.eoneNumber}`,
                            );
                        }
                    });
            } else {
                this.props.history.push(
                    `/messageList?eoneNumber=${currentShipmentOrOrderDetails.eoneNumber}`,
                );
            }
        }
    };

    getLinkParamState = () => {
        let tabState = '';
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });
        if (typeof this.params.tabFlag !== 'undefined') {
            tabState = this.params.tabFlag;
        }
        return tabState;
    };

    showDisplayCancelBtn = (shipmentOrOrderDetails) => {
        const {localData} = this.props;
        let showCancelBtnFlag = false;
        // shipmentOrOrderDetails.status !== -1 ||
        //                         shipmentOrOrderDetails.status !== 4
        if (localData.roleType === USER_ROLE.ADMIN) {
            if (
                shipmentOrOrderDetails.status !== -1 ||
                shipmentOrOrderDetails.status !== 4
            ) {
                showCancelBtnFlag = true;
            }
        }
        return showCancelBtnFlag;
    };

    copyAll = (currentOrderNumber, currentPurchaseNo, shipments) => {
        let skuContent = [];

        shipments &&
            shipments[0] &&
            shipments[0].shipmentProducts.length > 0 &&
            shipments[0].shipmentProducts.map(
                (shipmentProductItem, shipmentProductIndex) => {
                    let skuLabel =
                        'SKU' +
                        ++shipmentProductIndex +
                        ': ' +
                        shipmentProductItem.product.sku;
                    let skuQuantity = T('cancellation_of_package_message5', [
                        shipmentProductItem.quantity,
                    ]);
                    skuContent.push(`${skuLabel}    ${skuQuantity}`);
                },
            );

        let orderNumber = T('cancellation_of_package_message2', [
            currentOrderNumber,
        ]);
        let purchaseNo = T('cancellation_of_package_message3', [
            currentPurchaseNo,
        ]);

        copy(`${orderNumber}\n${purchaseNo}\n${skuContent.join('\n')}`);

        // this.props.openNotification(T('notification_copy_success'), 'success');
    };

    showShippingPlanHandle = (orderData, orderProduct) => {
        let params = {
            orderId: orderData.id,
            sku: orderProduct.product.sku,
            orderProductId: orderProduct.id,
        };
        let planArr = [];
        this.props.getShippingPlanList(params).then((res) => {
            if (
                res &&
                res.status === 'success' &&
                res.data &&
                res.data.items &&
                res.data.items.length > 0
            ) {
                res.data.items.map((planItem) => {
                    planArr.push({
                        id: planItem.id,
                        shippingPlanId: planItem.id,
                        shippingDate: planItem.shippingDate,
                        quantity: planItem.quantity,
                        remark: planItem.remark,
                    });
                });
            } else {
                planArr = this.state.shippingPlanModalComps;
            }
            this.setState({
                isOpenShippingPlanDialog: true,
                currentOrderData: orderData,
                currentOrderProduct: orderProduct,
                shippingPlanData: planArr,
            });
        });
    };

    closeShippingPlanDialog = () => {
        if (this.state.isOpenShippingPlanDialog) {
            this.setState({
                isOpenShippingPlanDialog: false,
                shippingPlanData: [],
                shippingPlanModalComps: [
                    {
                        shippingPlanId: 1,
                        quantity: 1,
                        shippingDate: util.dateFilter(
                            new Date().setDate(new Date().getDate()),
                            'yyyy-MM-dd',
                        ),
                        remark: '',
                    },
                ],
            });
        }
    };

    saveShippingPlanHandle = (currentOrderProduct, myOrderData) => {
        let {shippingPlanData} = this.state;
        let params = {
            orderId: myOrderData.id,
            orderNumber: myOrderData.number,
            orderProductId: currentOrderProduct.id,
            sku: currentOrderProduct.product.sku,
            items: util.getShippingPlanParam(shippingPlanData),
        };
        console.log(
            'util.isShippingDateNull(shippingPlanData).isQuantityFlag',
            util.isShippingDateNull(shippingPlanData).isQuantityFlag,
        );
        if (util.isShippingDateNull(shippingPlanData).isQuantityFlag) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_shipped_quantity_not_null',
            });
        } else if (
            util.isShippingDateNull(shippingPlanData).isShippingDateFlag
        ) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_shipped_date_not_null',
            });
        } else {
            if (
                this.getAddedQuantityOfShippingPlans() <=
                currentOrderProduct.quantity
            ) {
                if (util.isRequireSubmit(shippingPlanData)) {
                    this.props.saveShippingPlan(params).then((res) => {
                        if (res && res.status === 'success') {
                            this.props.updateShipmentOrderDetails({
                                $set: util.updateCurrentShippingPlanFlag(
                                    currentOrderProduct,
                                    myOrderData,
                                ),
                            });

                            this.props.openNotification(
                                T('shipping_plan_add_success'),
                                'success',
                            );

                            this.closeShippingPlanDialog();
                        }
                    });
                } else {
                    this.closeShippingPlanDialog();
                }
            } else {
                this.setState({
                    showTip: true,
                    currentTipMessage:
                        'shipping_plan_quantity_cannot_exceed_total_quantity_SKUs',
                });
            }
        }
    };

    isDeletePlanFlag = (deleteShippingId) => {
        let {shippingPlanData} = this.state;
        let isDeleteFlag = true;
        if (shippingPlanData.length > 0) {
            shippingPlanData.map((planItem) => {
                if (
                    planItem.id &&
                    planItem.shippingPlanId === deleteShippingId
                ) {
                    isDeleteFlag = false;
                }
            });
        }

        return isDeleteFlag;
    };

    deleteShippingPlanHandle = (comps) => {
        let {shippingPlanData} = this.state;
        if (!this.isDeletePlanFlag(comps)) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_added_plan_cannot_delete',
            });
        } else {
            if (shippingPlanData.length > 1) {
                shippingPlanData.splice(
                    shippingPlanData.findIndex(
                        (item) => item.shippingPlanId === comps,
                    ),
                    1,
                );

                this.setState({
                    shippingPlanData: shippingPlanData,
                });
            } else {
                this.setState({
                    showTip: true,
                    currentTipMessage: 'shipping_plan_needed_one_plan',
                });
            }
        }
    };

    addShippingPlanItemHandle = (skuQuantity) => {
        let {shippingPlanData, shippingPlanNum} = this.state;

        if (this.getAddedQuantityOfShippingPlans() < skuQuantity) {
            shippingPlanData.push({
                shippingPlanId: shippingPlanNum + 1,
                quantity: 1,
                shippingDate: util.dateFilter(
                    new Date().setDate(new Date().getDate()),
                    'yyyy-MM-dd',
                ),
                remark: '',
            });

            this.setState({
                shippingPlanData: shippingPlanData,
                shippingPlanNum: ++shippingPlanNum,
            });
        } else {
            // this.closeShippingPlanDialog();//TODO
            this.setState({
                showTip: true,
                currentTipMessage:
                    'shipping_plan_quantity_cannot_exceed_total_quantity_SKUs',
            });
            // this.props.openNotification(
            //     T('shipping_plan_quantity_cannot_exceed_total_quantity_SKUs'),
            // );
        }
    };

    eidtShippingDateHandle = (title, value) => {
        let number = parseInt(title.split('-')[1]);
        let currentshippingPlanData = JSON.parse(
            JSON.stringify(this.state.shippingPlanData),
        );
        currentshippingPlanData.forEach((shippingPlanModal, skuIndex) => {
            if (number === shippingPlanModal.shippingPlanId) {
                shippingPlanModal.shippingDate = value;
            }
        });
        this.setState({
            [title]: value,
            shippingPlanData: currentshippingPlanData,
        });
    };

    eidtShippingPlanRQuantityHandle = (value, currentIndex) => {
        console.log(
            'value, currentIndex, eidtShippingPlanRQuantityHandle',
            value,
            currentIndex,
        );
        let currentValue = value;
        if (value && util.isString(value)) {
            currentValue = parseInt(value);
        }
        this.setState((prevState) => {
            const currentShippingPlanData = prevState.shippingPlanData.map(
                (shippingPlanModal) => {
                    if (currentIndex === shippingPlanModal.shippingPlanId) {
                        return {
                            ...shippingPlanModal,
                            quantity: currentValue,
                        };
                    }
                    return shippingPlanModal;
                },
            );

            return {
                shippingPlanData: currentShippingPlanData,
            };
        });
    };

    getAddedQuantityOfShippingPlans = () => {
        let currentshippingPlanData = JSON.parse(
            JSON.stringify(this.state.shippingPlanData),
        );

        let addedShippingPlanQuantity = 0;
        currentshippingPlanData.length > 0 &&
            currentshippingPlanData.map((shippingPlanItem) => {
                addedShippingPlanQuantity += shippingPlanItem.quantity;
            });

        return addedShippingPlanQuantity;
    };

    getEoneHoldLockTypes = (lockType) => {
        const originalLockType = util.getLockedTypeOriginalValue(lockType);
        if (!originalLockType) {
            return [];
        }

        return originalLockType
            .split('&')
            .map((item) => item.trim())
            .filter(Boolean);
    };

    render() {
        const {
            previewReceiveImageDialogOpened,
            previewOtherImagesDialogOpened,
            noOtherPhotosDialogOpened,
            uploadReceiveImageDialogOpened,
            cancelOrderDialogOpened,
            cancelWithdrawalPackage,
            notShipDialogOpened,
            chooseShipmentItem,
            currentOtherImageIndex,
            chooseImage,
            uploadFileBtnIsLoading,
            skuInventoryExitOpened,
            sQuoteFailureDialogOpened,
            currentShipFlag,
            waitSendGoodsDialogOpened,
            addTrackNumberDialogOpened,
            trackNumber,
            currentShipments,
            messageCount,
            opentForceShipDialog,
            currentB2bShipmentFlag,
            currentOrderNumber,
            currentPurchaseNo,

            currentOrderProducts,
            isOpenShippingPlanDialog,
            shippingPlanData,
            currentOrderProduct,
            currentTipMessage,
            showTip,
            detailsLoading,
        } = this.state;
        const {
            shipmentOrOrderDetails,
            skuInventoryDetails,
            localData,
            packageQuantity,
        } = this.props;
        let lang = loadLanguage();

        const location = parseInt(this.getLinkParamState());
        const eoneHoldLockTypes = this.getEoneHoldLockTypes(
            shipmentOrOrderDetails.lockType,
        );
        const isHaveShipmentImage =
            chooseShipmentItem && chooseShipmentItem.receiveImg;

        if (detailsLoading) {
            return (
                <div className="shipment-details-container">
                    <div className="header-wrap">
                        <div className="shipment-details-header container-max-width is-fixed">
                            <Anchor
                                className="go-back"
                                onClickOfSingleTap={this.goBack}>
                                <ArrowBackIos />
                            </Anchor>
                            {T('shippment_order_details')}
                        </div>
                    </div>
                    <LoadingIcon className="circle-animation" />
                </div>
            );
        }

        return (
            <div className="shipment-details-container">
                <div
                    className={util.getClassName({
                        'header-wrap':
                            true &&
                            (shipmentOrOrderDetails.lockType === 'unLock' ||
                                shipmentOrOrderDetails.lockType === 'No' ||
                                !shipmentOrOrderDetails.lockType),
                        'lock-header-wrap':
                            true &&
                            lang !== 'EN' &&
                            (util.getLockedType(shipmentOrOrderDetails) ===
                                'checking' ||
                                ((this.params.tabFlag === '1' ||
                                    this.params.tabFlag === '2') &&
                                    (shipmentOrOrderDetails.status === 1 ||
                                        shipmentOrOrderDetails.status === 2) &&
                                    shipmentOrOrderDetails.b2bShipmentFlag ===
                                        'Y')),
                        'credit-lock-header-wrap':
                            true &&
                            lang !== 'EN' &&
                            (util.getLockedType(shipmentOrOrderDetails) ===
                                'financialLocked' ||
                                util.getLockedType(shipmentOrOrderDetails) ===
                                    'addingC2Locked'),
                        'en-lock-header-wrap':
                            true &&
                            lang === 'EN' &&
                            (util.getLockedType(shipmentOrOrderDetails) ===
                                'checking' ||
                                (shipmentOrOrderDetails.status === 3 &&
                                    shipmentOrOrderDetails.b2bShipmentFlag ===
                                        'Y')),
                        'en-credit-lock-header-wrap':
                            true &&
                            lang === 'EN' &&
                            (util.getLockedType(shipmentOrOrderDetails) ===
                                'financialLocked' ||
                                util.getLockedType(shipmentOrOrderDetails) ===
                                    'addingC2Locked'),
                    })}>
                    <div className="shipment-details-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        {T('shippment_order_details')}
                        {messageCount && messageCount.messageCount > 0 ? (
                            <div className="message-count-container">
                                {messageCount.unReadCount > 0 ? (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_unread_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                ) : (
                                    <img
                                        src={
                                            new URL(
                                                'Images/detail_read_message.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                        onClick={this.goToMessageList}
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>

                    {util.getLockedType(shipmentOrOrderDetails) ===
                        'checking' ||
                    util.getLockedType(shipmentOrOrderDetails) ===
                        'financialLocked' ||
                    util.getLockedType(shipmentOrOrderDetails) ===
                        'addingC2Locked' ? (
                        <div className="notice-lock container-max-width is-fixed">
                            <div className="notice-lock-text">
                                {T(
                                    util.getLockedTypeMessage(
                                        shipmentOrOrderDetails,
                                    ),
                                )}
                            </div>
                        </div>
                    ) : (
                        (this.params.tabFlag === '1' ||
                            this.params.tabFlag === '2') &&
                        (shipmentOrOrderDetails.status === 1 ||
                            shipmentOrOrderDetails.status === 2) &&
                        util.getLockedType(shipmentOrOrderDetails) ===
                            'noLocked' &&
                        shipmentOrOrderDetails.b2bShipmentFlag === 'Y' && (
                            <div className="notice-lock container-max-width is-fixed">
                                <div className="notice-lock-text">
                                    {T(
                                        util.getb2bCasmatShipmentMessage(
                                            shipmentOrOrderDetails,
                                        ),
                                    )}
                                </div>
                            </div>
                        )
                    )}
                </div>
                <div className="content-box">
                    <p className="supply-center-name">
                        <label>{T('supplyCenter')}</label>{' '}
                        {shipmentOrOrderDetails.scName}
                    </p>
                    <p className="order-number">
                        <label>{T('shippment_order_number')}</label>{' '}
                        {shipmentOrOrderDetails.number}
                    </p>
                    <p className="EONE-order-number">
                        <div className="e1-order-area">
                            <label>{T('shippment_eone_number')}</label>{' '}
                            {shipmentOrOrderDetails.eoneNumber}
                        </div>
                        {localData.roleType == USER_ROLE.HOST &&
                        shipmentOrOrderDetails.actualTransportMethod ? (
                            <div className="delivery-method-area">
                                {T('(')}
                                {shipmentOrOrderDetails.actualTransportMethod ===
                                'Direct'
                                    ? T('direct_method')
                                    : shipmentOrOrderDetails.actualTransportMethod ===
                                      'N'
                                    ? T('order_no_name')
                                    : T('mail_method')}
                                {T(')')}
                            </div>
                        ) : null}
                    </p>
                    {eoneHoldLockTypes.length > 0 ? (
                        <p className="EONE-order-status eone-hold">
                            <label>{T('order_eone_hold')}</label>{' '}
                            <span className="eone-hold-tags">
                                {eoneHoldLockTypes.map((lockType, index) => (
                                    <span
                                        className="eone-hold-tag"
                                        testid={`eone-hold-tag-${lockType}`}
                                        key={`${lockType}-${index}`}>
                                        {lockType}
                                    </span>
                                ))}
                            </span>
                        </p>
                    ) : null}
                    {shipmentOrOrderDetails.status !== -1 ? (
                        <p className="buy-time">
                            <label>{T('shippment_purchase_date')}</label>
                            {shipmentOrOrderDetails.createTime}
                        </p>
                    ) : null}
                    {shipmentOrOrderDetails.status === -1 ? (
                        <p className="cancel-time">
                            <label>{T('shippment_cancel_date')}</label>
                            {shipmentOrOrderDetails.cancelTime}
                        </p>
                    ) : null}
                </div>
                {typeof this.params.tabFlag !== 'undefined' &&
                this.params.tabFlag === '3' &&
                shipmentOrOrderDetails.shipments &&
                shipmentOrOrderDetails.shipments.length ? (
                    <ul className="shipment-list">
                        {shipmentOrOrderDetails.shipments.map((item, index) => (
                            <li className="shipment-item" key={index}>
                                <div className="shipment-files">
                                    <span className="shipment-invoice">
                                        <label>
                                            {T('shippment_delivery_order')}
                                        </label>
                                        <Anchor
                                            className="btn"
                                            onClickOfSingleTap={() =>
                                                this.previewInvoice(item)
                                            }>
                                            {T('shippment_preview')}
                                        </Anchor>
                                        {shipmentOrOrderDetails.status === -1 ||
                                        shipmentOrOrderDetails.status === 4 ? (
                                            <BasicButton
                                                type=""
                                                className="add-track-number"
                                                onClickOfSingleTap={() =>
                                                    this.openTrackNumberDialog(
                                                        item,
                                                    )
                                                }
                                                isStopPropagation={true}>
                                                {T(
                                                    'shippment_add_tracking_number',
                                                )}
                                            </BasicButton>
                                        ) : null}
                                    </span>
                                    <span className="shipment-receive-image">
                                        <label>
                                            {T('shippment_sign_receipt')}
                                        </label>{' '}
                                        <Anchor
                                            className="btn"
                                            onClickOfSingleTap={() =>
                                                this.previewReceiveImage(item)
                                            }>
                                            {T('shippment_preview')}
                                        </Anchor>{' '}
                                        {item.status === 4 ? (
                                            <Anchor
                                                className="btn"
                                                onClickOfSingleTap={() =>
                                                    this.handleUploadReceiveImageDialog(
                                                        item,
                                                    )
                                                }>
                                                {T('shippment_upload_again')}
                                            </Anchor>
                                        ) : null}
                                    </span>
                                </div>
                                <div className="shipment-other-images">
                                    <label>
                                        {T('shippment_upload_other_photos')}
                                    </label>
                                    {item.otherImages &&
                                    item.otherImages.length > 0 ? (
                                        <Anchor
                                            className="btn"
                                            onClickOfSingleTap={() =>
                                                this.previewOtherImages(item)
                                            }>
                                            {T('shippment_preview')}
                                        </Anchor>
                                    ) : (
                                        <Anchor
                                            className="btn"
                                            onClickOfSingleTap={() =>
                                                this.setState({
                                                    noOtherPhotosDialogOpened: true,
                                                })
                                            }>
                                            {T('shippment_preview')}
                                        </Anchor>
                                    )}
                                </div>
                                {item.expressNumber ? (
                                    <p className="express-number">
                                        <label>
                                            {T('shippment_express_number')}
                                        </label>
                                        {item.expressNumber}
                                    </p>
                                ) : null}
                                {item.receivedTime ? (
                                    <p className="received-time">
                                        <label>
                                            {T('shippment_sign_date')}
                                        </label>
                                        {item.receivedTime}
                                    </p>
                                ) : (
                                    <p className="ship-time">
                                        <label>
                                            {T('shippment_delivery_date')}
                                        </label>
                                        {item.createTime}
                                    </p>
                                )}

                                {shipmentOrOrderDetails.b2bShipmentFlag ===
                                    'Y' && (
                                    <div className="b2b-casmart-btn-container">
                                        <img
                                            src={base64ShippingImage}
                                            alt="Base64 Image"
                                        />
                                        <label>
                                            {T('shippment_b2b_casmart_btn')}
                                        </label>
                                        <div
                                            className="b2b-casmart-order-priview"
                                            onClick={() =>
                                                this.b2bCasmartShipmentHandle({
                                                    shipmentId: item.id,
                                                    orderId: item.orderId,
                                                })
                                            }>
                                            {T('shippment_preview')}
                                        </div>
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : null}
                {typeof this.params.tabFlag !== 'undefined' &&
                this.params.tabFlag === '3' ? null : (
                    <div className="shipped-detail-container">
                        <h4 className="ship-to-detail-title">
                            <div className="deliver-title">
                                {T('shippment_delivery_details')}
                            </div>
                            <div
                                className="deliver-quantity"
                                onClick={this.deliverInfor}>
                                {T('shipment_delivered_package_count', [
                                    packageQuantity &&
                                        typeof packageQuantity.data !==
                                            'undefined' &&
                                        packageQuantity.data,
                                ])}
                                <NavigateNext className="navigate-next-icon" />
                            </div>
                        </h4>
                    </div>
                )}
                <OrderShipToDetail
                    className="ship-to-info"
                    data={shipmentOrOrderDetails}></OrderShipToDetail>
                <OrderBillToDetail
                    className="bill-to-info"
                    data={shipmentOrOrderDetails}></OrderBillToDetail>
                <OrderPurchaseNo
                    className="order-purchase-no"
                    purchaseNo={
                        shipmentOrOrderDetails.purchaseNo
                    }></OrderPurchaseNo>
                <OrderRemark
                    className={util.getClassName({
                        'order-remark': true && lang !== 'EN',
                        'en-order-remark': true && lang === 'EN',
                    })}
                    remark={shipmentOrOrderDetails.remark}></OrderRemark>
                {typeof shipmentOrOrderDetails !== 'undefined' ? (
                    <OrderProductList
                        className="products"
                        data={shipmentOrOrderDetails}
                        roleType={localData.roleType}
                        options={{
                            inventoryKey: 'physicalInventory',
                            showQuantity: true,
                            showShipQuantity: false,
                        }}
                        tabFlag={location}
                        openShippingPlan={this.showShippingPlanHandle}
                        showSkuInventoryDetailHandle={
                            this.showSkuInventoryDetailHandle
                        }></OrderProductList>
                ) : null}

                <div className="footer-warp">
                    {shipmentOrOrderDetails.status === 4 ||
                    shipmentOrOrderDetails.status === -1 ||
                    this.params.tabFlag === '4' ? null : (
                        <div
                            className={util.getClassName({
                                'shipment-details-footer container-max-width is-fixed':
                                    true && lang !== 'EN',
                                'en-shipment-details-footer container-max-width is-fixed':
                                    true && lang === 'EN',
                            })}>
                            <div>
                                {this.showDisplayCancelBtn(
                                    shipmentOrOrderDetails,
                                ) ? (
                                    <BasicButton
                                        className="cancel-btn"
                                        type="info"
                                        onClickOfSingleTap={
                                            this.openCancelOrderDialog
                                        }>
                                        {T('shippment_cancel_order')}
                                    </BasicButton>
                                ) : null}
                                {location === 3 ? (
                                    <BasicButton
                                        className="cancel-btn withdrawal_of_package"
                                        type="info"
                                        onClickOfSingleTap={
                                            this.openWithdrawalPackage
                                        }>
                                        {T('withdrawal_of_package')}
                                    </BasicButton>
                                ) : null}
                            </div>
                            <div className="shippment-right-btn">
                                {shipmentOrOrderDetails.status === 2 ? (
                                    <BasicButton
                                        className="not-ship-btn"
                                        type="danger"
                                        onClickOfSingleTap={
                                            this.openWaitSendGoodsDialog
                                        }>
                                        {T('to_send_the_goods')}
                                    </BasicButton>
                                ) : null}
                                {shipmentOrOrderDetails.status === 1 ? (
                                    <BasicButton
                                        className="not-ship-btn"
                                        type="danger"
                                        onClickOfSingleTap={
                                            this.openNotShipDialog
                                        }>
                                        {T('shippment_temporary_not_delivery')}
                                    </BasicButton>
                                ) : null}
                                {shipmentOrOrderDetails.status === 1 ||
                                shipmentOrOrderDetails.status === 2 ? (
                                    <BasicButton
                                        type="primary"
                                        className={
                                            (currentShipFlag === 1
                                                ? 'all-shippment-btn'
                                                : currentShipFlag === 2
                                                ? 'partial-shippment-btn'
                                                : '') +
                                            (util.getLockedType(
                                                shipmentOrOrderDetails,
                                            ) === 'checking' ||
                                            util.getLockedType(
                                                shipmentOrOrderDetails,
                                            ) === 'financialLocked' ||
                                            currentShipFlag === 3
                                                ? ' shippment-disabled-btn'
                                                : '')
                                        }
                                        onClickOfSingleTap={this.ship}
                                        disabled={
                                            util.getLockedType(
                                                shipmentOrOrderDetails,
                                            ) === 'checking' ||
                                            util.getLockedType(
                                                shipmentOrOrderDetails,
                                            ) === 'financialLocked' ||
                                            currentShipFlag === 3
                                                ? true
                                                : false
                                        }>
                                        {currentShipFlag === 1
                                            ? T('shippment_all_available')
                                            : currentShipFlag === 2
                                            ? T('shippment_partial_shipping')
                                            : T('shippment_not_shipping')}
                                    </BasicButton>
                                ) : null}
                            </div>
                        </div>
                    )}
                </div>
                <Dialog
                    opened={previewReceiveImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewReceiveImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className={`preview-shipment-receive-image-dialog ${
                            !isHaveShipmentImage
                                ? 'shipment-receive-image-no-image'
                                : ''
                        }`}>
                        {chooseShipmentItem && chooseShipmentItem.receiveImg ? (
                            <img
                                src={this.getPreviewImageUrl(
                                    chooseShipmentItem.receiveImg,
                                )}
                                alt={this.getPreviewImageUrl(
                                    chooseShipmentItem.receiveImg,
                                )}
                            />
                        ) : (
                            T('shippment_not_upload_sign_receipt')
                        )}
                    </div>
                </Dialog>
                <Dialog
                    opened={previewOtherImagesDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewOtherImagesDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-shipment-other-images-dialog">
                        {chooseShipmentItem &&
                        chooseShipmentItem.otherImages &&
                        chooseShipmentItem.otherImages.length > 0 ? (
                            <>
                                <div className="preview-shipment-other-images-main">
                                    <img
                                        src={this.getPreviewImageUrl(
                                            chooseShipmentItem.otherImages[
                                                currentOtherImageIndex
                                            ].imageUrl,
                                        )}
                                        alt=""
                                    />
                                </div>
                                <div className="preview-shipment-other-images-list">
                                    {chooseShipmentItem.otherImages.map(
                                        (otherImage, otherImageIndex) => (
                                            <button
                                                type="button"
                                                className={util.getClassName({
                                                    'preview-shipment-other-images-item': true,
                                                    'is-active':
                                                        currentOtherImageIndex ===
                                                        otherImageIndex,
                                                })}
                                                key={
                                                    otherImage.id ||
                                                    otherImageIndex
                                                }
                                                onClick={() =>
                                                    this.setPreviewOtherImageIndex(
                                                        otherImageIndex,
                                                    )
                                                }>
                                                <img
                                                    src={this.getPreviewImageUrl(
                                                        otherImage.imageUrl,
                                                    )}
                                                    alt=""
                                                />
                                            </button>
                                        ),
                                    )}
                                </div>
                                <BasicButton
                                    type="primary"
                                    className="preview-shipment-other-images-close-btn"
                                    onClickOfSingleTap={() =>
                                        this.dialogDidClose(
                                            'previewOtherImagesDialogOpened',
                                        )
                                    }>
                                    {T('close')}
                                </BasicButton>
                            </>
                        ) : (
                            T('shippment_not_upload_other_photos')
                        )}
                    </div>
                </Dialog>
                <Dialog
                    opened={noOtherPhotosDialogOpened}
                    dialogDidClose={() =>
                        this.setState({noOtherPhotosDialogOpened: false})
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-shipment-receive-image-dialog  shipment-receive-image-no-image">
                        {T('shippment_not_upload_other_photos')}
                    </div>
                </Dialog>
                <Dialog
                    opened={uploadReceiveImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('uploadReceiveImageDialogOpened')
                    }
                    options={{bgClickClose: !uploadFileBtnIsLoading}}>
                    <ShipmentReceiveWithOtherPhotosDialog
                        opened={uploadReceiveImageDialogOpened}
                        uploadFileBtnIsLoading={uploadFileBtnIsLoading}
                        lang={lang}
                        mode="update"
                        lockReceiveMethod={true}
                        onClose={() =>
                            this.dialogDidClose(
                                'uploadReceiveImageDialogOpened',
                            )
                        }
                        maskedPhone={shipmentOrOrderDetails.receiverTel}
                        shipment={shipmentOrOrderDetails}
                        shipmentId={
                            chooseShipmentItem ? chooseShipmentItem.id : null
                        }
                        initialReceiveMethod={this.getShipmentReceiveMethod(
                            chooseShipmentItem,
                        )}
                        initialMainImageUrl={this.getShipmentMainImageUrl(
                            chooseShipmentItem,
                        )}
                        initialMainImageKey={this.getShipmentMainImageKey(
                            chooseShipmentItem,
                        )}
                        initialOtherImages={
                            chooseShipmentItem && chooseShipmentItem.otherImages
                                ? chooseShipmentItem.otherImages
                                : []
                        }
                        onLoadingChange={(loading) =>
                            this.setState({uploadFileBtnIsLoading: loading})
                        }
                        onSuccess={() => {
                            this.props.openNotification(
                                T('notification_successfully_upload'),
                                'success',
                            );
                            this.setState({
                                uploadReceiveImageDialogOpened: false,
                                chooseShipmentItem: null,
                            });
                            this.getInitData();
                        }}
                    />
                </Dialog>
                <Dialog
                    opened={cancelOrderDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelOrderDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="cancel-order-dialog">
                        <h5 className="cancel-order-dialog-title text-center">
                            {T('shippment_cancel_order')}
                        </h5>
                        <p className="cancel-order-dialog-desc text-center">
                            {T('shippment_confirm_cancel_order')}
                        </p>
                        <BasicButton
                            type="primary"
                            className="cancel-order-confirm-btn"
                            onClickOfSingleTap={this.cancelOrder}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={cancelWithdrawalPackage}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelWithdrawalPackage')
                    }
                    options={{bgClickClose: true}}>
                    <div className="cancel-order-dialog">
                        <h5 className="cancel-order-dialog-title text-center">
                            {T('withdrawal_of_package')}
                        </h5>
                        <p className="cancel-order-dialog-desc shipment-detail-cancel-package">
                            {T('confirm_cancellation_of_package')}
                            {currentB2bShipmentFlag === 'Y' ? (
                                <div className="b2b-castmart-reminder-info">
                                    <div className="left-margin first-row">
                                        <div>
                                            {T(
                                                'cancellation_of_package_message2',
                                                [currentOrderNumber],
                                            )}
                                        </div>
                                        <div
                                            className="all-copy"
                                            onClick={() => {
                                                this.copyAll(
                                                    currentOrderNumber,
                                                    currentPurchaseNo,
                                                    currentOrderProducts,
                                                );
                                            }}>
                                            {T('cancellation_of_package_copy')}
                                        </div>
                                    </div>
                                    <div className="left-margin">
                                        {T('cancellation_of_package_message3', [
                                            currentPurchaseNo,
                                        ])}
                                    </div>
                                    {currentOrderProducts &&
                                        currentOrderProducts[0] &&
                                        currentOrderProducts[0].shipmentProducts
                                            .length > 0 &&
                                        currentOrderProducts[0].shipmentProducts.map(
                                            (orderProduct, orderIndex) => (
                                                <div className="left-margin">
                                                    <div>
                                                        {T(
                                                            'cancellation_of_package_message4',
                                                            [++orderIndex],
                                                        )}
                                                        {
                                                            orderProduct.product
                                                                .sku
                                                        }
                                                    </div>
                                                    <div>
                                                        {T(
                                                            'cancellation_of_package_message5',
                                                            [
                                                                orderProduct.quantity,
                                                            ],
                                                        )}
                                                    </div>
                                                </div>
                                            ),
                                        )}
                                    <div className="warning-info">
                                        {/* <div className='first-warning-info'>
                                            <Info />
                                        </div> */}
                                        <div className="second-warning-info">
                                            {T(
                                                'cancellation_of_package_message1',
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </p>
                        <div className="button-contanier">
                            <BasicButton
                                type="primary"
                                className="confirm-action-btn confirm-cancel-btn"
                                onClickOfSingleTap={this.cancelDialog}>
                                {T('btn_action_cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-order-confirm-btn"
                                onClickOfSingleTap={this.withdrawalPackage}>
                                {T('shippment_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={notShipDialogOpened}
                    testid="shipment_details_onhold_dialog"
                    dialogDidClose={() =>
                        this.dialogDidClose('notShipDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_temporary_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_temporary_delivery')}</p>
                            <p>{T('shippment_see_temporary_delivery_list')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="not-ship-confirm-btn"
                            testid="shipment_details_onhold_dialog_confirm_btn"
                            onClickOfSingleTap={this.notShip}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={waitSendGoodsDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('waitSendGoodsDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_wait_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_wait_delivery')}</p>
                            <p>{T('shippment_see_wait_delivery_list')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="not-ship-confirm-btn"
                            onClickOfSingleTap={this.waitSendGoods}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={sQuoteFailureDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('sQuoteFailureDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    {
                        <div className="cancel-order-dialog">
                            <h5 className="cancel-order-dialog-title text-center">
                                {T('order_cancel_order')}
                            </h5>
                            <div className="cancel-order-dialog-desc text-center ">
                                <p>
                                    {localData.roleType == 0
                                        ? T(
                                              'order_quote_order_by_service_customer',
                                          )
                                        : T('order_quote_order_by_service')}
                                </p>
                                <p>{T('order_service_email')}</p>
                            </div>
                        </div>
                    }
                </Dialog>
                <SkuInventoryDetailsDialog
                    skuReplenishmentDetailData={skuInventoryDetails}
                    closeDialog={this.closeDialog}
                    opened={skuInventoryExitOpened}
                    isOperateFlag="ship"
                />

                <ShippingPlanDialog
                    myOrderData={shipmentOrOrderDetails}
                    closeDialog={this.closeShippingPlanDialog}
                    opened={isOpenShippingPlanDialog}
                    addedShippingPlanData={shippingPlanData}
                    currentOrderProduct={currentOrderProduct}
                    saveShippingPlan={this.saveShippingPlanHandle}
                    deleteShippingPlan={this.deleteShippingPlanHandle}
                    addShippingPlanItem={this.addShippingPlanItemHandle}
                    currentTipMessage={currentTipMessage}
                    showTip={showTip}
                    eidtShippingDate={this.eidtShippingDateHandle}
                    eidtShippingPlanRQuantity={
                        this.eidtShippingPlanRQuantityHandle
                    }
                    isOperateFlag="addShippingPlan"
                />

                <Dialog
                    opened={addTrackNumberDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('addTrackNumberDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="track-number-dialog">
                        <h5 className="track-number-dialog-title text-center">
                            {T('shippment_input_tracking_number')}
                        </h5>
                        <div className="input-track-number">
                            <BasicInput
                                placeholder={T(
                                    'shippment_please_input_tracking_number',
                                )}
                                title=""
                                className="track-number-basic-input"
                                defaultValue={
                                    typeof currentShipments !== 'undefined' &&
                                    currentShipments.expressNumber
                                }
                                value={trackNumber}
                                inputValid={this.handleChange}
                            />
                        </div>
                        <BasicButton
                            type="primary"
                            className="add-track-number-confirm-btn"
                            onClickOfSingleTap={this.addTrackNumberHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={opentForceShipDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('opentForceShipDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="force-ship-dialog">
                        <h5 className="force-ship-dialog-title text-center">
                            {T('shipment_order_shippe_separately')}
                        </h5>
                        <p className="force-ship-dialog-desc">
                            {T('shipment_picking_order_is_separately_shipment')}
                        </p>
                        <div className="force-ship-btn-container">
                            <BasicButton
                                type="primary"
                                className="force-ship-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmForceShipHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose('opentForceShipDialog')
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData, myOrder} = state;
    return {
        shipmentOrOrderDetails: host.shipmentOrOrderDetails,
        skuInventoryDetails: host.skuInventoryDetails,
        localData,
        packageQuantity: host.packageQuantity,
        orderDetailMessageCount: host.orderDetailMessageCount,
        currentPageNum: host.currentPageNum,
        currentShipmentId: host.currentShipmentId,
        revokePackageSuccessFlag: host.revokePackageSuccessFlag,

        salesOnholdStatusFlag: myOrder.salesOnholdStatusFlag,
        currentOrderId: myOrder.currentOrderId,
        currentPageNum: myOrder.currentPageNum,

        shippingPlanDetails: myOrder.shippingPlanDetails,
    };
};

const mapDispatchToProps = {
    getOrderDetails,
    openNotification,
    updateShipment,
    cancelOrder,
    cancelPackage,
    notShipOrder,
    waitShipOrder,
    createInvoicePdf,
    getSkuInventoryDetails,
    updateTrackingNumber,
    getShipmentPackageQuantity,
    getOrderDetailMessageCount,
    getOrderDetailOneKeyRead,
    forceCancelPickOrder,
    setShipmentsSource,
    setRevokePackageSuccess,
    setCurrentShipmentId,
    punchReceivable,
    b2bCasmartShipment,

    saveShippingPlan,
    getShippingPlanList,
    updateShipmentOrderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentDetails);
